import * as firebase from 'firebase'
import * as React from 'react'
import { Redirect } from 'react-router-dom'

const Logout = () => {
  firebase.auth().signOut()
  return <Redirect to="/" />
}

export default Logout



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Logout.tsx